class NSSCardProduct extends HTMLElement {

  constructor() {
    super();

    this.debug = false;
    this.formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', });
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Card Product] Connected.");

    const idEl = this.querySelector(`[name="id"]`);
    idEl.addEventListener(`change`, this.variantChange.bind(this));

    const radioEls = this.querySelectorAll(`[name="frequency"]`);
    radioEls.forEach((radioEl) => {
      radioEl.addEventListener(`click`, this.frequencyChange.bind(this));
    });

    const planSelectEl = this.querySelector(`[name="plan_select"]`);
    if (planSelectEl) {
      planSelectEl.addEventListener(`change`, this.planSelectChange.bind(this));
    }
  }

  variantChange(e) {
    const variantId = e.target.value;
    if (this.debug) console.log("[NSS][Card Product] variantId:", variantId);
    this.swapContent(variantId);
  }

  swapContent(id) {
    const contentEls = this.querySelectorAll(`[nss-variant-id]`);
    contentEls.forEach((contentEl) => {
      contentEl.style.display = `none`;
    });
    const contentEl = this.querySelector(`[nss-variant-id="${id}"]`);
    contentEl.style.display = `flex`;

    const data = JSON.parse(this.querySelector(`script[id="${id}"]`).textContent);
    if (this.debug) console.log("[NSS][Card Product] data:", data);

    const otpEl = this.querySelector(`[nss-otp]`);
    this.updatePrices(data.compare_at_price, data.price, otpEl);

    const subEl = this.querySelector(`[nss-sub]`);
    this.updatePrices(data.sub_compare_at_price, data.sub_price, subEl);

    const atcBtnEl = this.querySelector(`[nss-btn-atc]`);
    const oosBtnEl = this.querySelector(`[nss-btn-oos]`);

    if (data.available) {
      atcBtnEl.style.display = `flex`;
      oosBtnEl.style.display = `none`;
    } else {
      atcBtnEl.style.display = `none`;
      oosBtnEl.style.display = `flex`;
    }
  }

  updatePrices(compare, price, el) {
    if (this.debug) console.log("[NSS][Card Product] compare:", compare);
    if (this.debug) console.log("[NSS][Card Product] price:", price);
    if (el) {
      const priceEl = el.querySelector(`[nss-price]`);
      const compareEl = el.querySelector(`[nss-compare]`);
  
      if (compare > price) {
        compareEl.style.display = `block`;
      } else {
        compareEl.style.display = `none`;
      }

      priceEl.textContent = this.formatter.format(price / 100);
      compareEl.textContent = this.formatter.format(compare / 100);
    }
  }

  frequencyChange(e) {
    const planSelectEl = e.target.closest(`label`).querySelector(`select`);
    if (planSelectEl) {
      const sellingPlanId = planSelectEl.value;
      this.sellingPlanUpdate(sellingPlanId);
    } else {
      this.sellingPlanUpdate("");
    }
  }

  planSelectChange(e) {
    this.sellingPlanUpdate(e.target.value);
  }

  sellingPlanUpdate(id) {
    const planEl = this.querySelector(`[name="selling_plan"]`);
    if (planEl) {
      planEl.value = id;
    }
  }
}

let elementName = `nss-card-product`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSCardProduct);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}